// Builds a slice's action-type constants: each name maps to a namespaced
// `"<name>/<CONSTANT>"` string. The `const` type parameter captures the input
// array as a tuple of string literals, so the result is typed with those exact
// keys (e.g. `constants.FETCH_POST`) rather than a loose `Record<string, string>`.
const createActionConstants = <const Names extends readonly string[]>(
  name: string,
  constants: Names
): Record<Names[number], string> =>
  constants.reduce(
    (acc, val) => ({
      ...acc,
      [val]: [name, val].join('/')
    }),
    {} as Record<Names[number], string>
  )

export default createActionConstants
